export const colorsMap = {
  none: 'transparent',
  inherit: 'inherit',
  'secondary-1': '#F8FAFF',
  'secondary-2': '#F1F6FF',
  'secondary-3': '#E8F0FF',
  'secondary-4': '#DDEAFE',
  'secondary-5': '#F8F9FB',
  'secondary-6': '#F3F3F3',
  'secondary-7': '#EAEAEA',
  'secondary-8': '#E3E3E3',
  'secondary-9': '#DADADA',
  'secondary-10': '#00C35A',
  'secondary-11': '#00B252',
  'secondary-12': '#397DFF',
  'secondary-13': '#FCB500',
  'secondary-14': '#6C47FF',
  'secondary-15': '#00CED4',
  'secondary-16': '#0C5EFF',
  'secondary-17': '#FCB000',
  'secondary-18': '#623CFA',
  'secondary-19': '#00C7D4',
  'secondary-20': '#397DFF',
  'secondary-21': '#00A542',
  'secondary-22': '#C62F00',
  'secondary-23': '#E0EAFF',
  'secondary-24': '#A5CBFF',
  'secondary-25': '#4293FF',
  'secondary-26': '#E0E0E0',
  'secondary-27': '#FFBA0A',
  'secondary-28': '#D7EDDC',
  'secondary-29': '#9EDFA4',
  'secondary-30': '#51C35C',
  'secondary-31': '#B2BAC8',
  'secondary-32': '#2D8AFA',
  'secondary-33': '#0BB859',
  'secondary-34': '#FFBE00',
  'secondary-35': '#F2F4F7',
  'secondary-36': '#272727',
  'secondary-37': '#4AC200',
  'secondary-39': '#FF4A31',
  'secondary-40': '#F6D89E',
  'secondary-41': '#F3D2D0',
  'secondary-42': '#FA9600',
  'secondary-44': '#00CD6B',
  'secondary-45': '#FF8718',
  'secondary-46': '#FF2618',
  'secondary-48': '#00D88E',
  'secondary-49': '#F3F6FA',
  'secondary-50': '#EDF1FA',
  'secondary-51': '#F5F7F9',
  'secondary-52': '#00C880',
  'secondary-53': '#00B530',
  'secondary-54': '#2C9AFF',
  'secondary-57': '#FFD600',
  'secondary-65': '#eef8f0',
  'secondary-68': '#2949C2',
  'secondary-69': '#E87D00',
  'secondary-70': '#F9F9F9',
  'secondary-71': '#FFF2F1',
  'secondary-72': '#3DFF70',
  'secondary-89': '#ff8c00',
  'basic-primary-black': '#000000',
  'basic-primary-blue': '#1573EF',
  'basic-primary-blue-hover': '#0B6BEA',
  'basic-primary-blue-active': '#0B6BEA',
  'basic-primary-new-blue': '#1380FF',
  'basic-primary-new-blue-hover': '#0176FF',
  'basic-primary-grey': '#1E2F4B',
  'basic-primary-lightgrey': '#F2F2F2',
  'basic-primary-white': '#FFFFFF',
  'basic-secondary-grey': '#8E96A4',
  'basic-secondary-white': '#FAFAFA',
  'basic-primary-error': '#FF938C',
  'secondary-grey': '#8E96A4',
  'secondary-white': '#FAFAFA',
  'secondary-light': '#ADB4C0',
  'filter-blue': '#F1F6FF',
  'filter-blue-active': '#E8F0FF',
  'filter-blue-hover': '#E8F0FF',
  'filter-grey': '#F3F3F3',
  'filter-grey-active': '#E3E3E3',
  'filter-grey-hover': '#EAEAEA',
  'filter-orange': '#FFF4DF',
  'filter-orange-hover': '#FFE8BB',
  'filter-orange-active': '#FFD89E',
  'stroke--1': '#F3F3F3',
  'stroke--2': '#E3E5E9',
  'stroke--3': '#C9CDD3',
  'stroke--4': '#1573EF',
  'text-active': '#1573EF',
  'text-grey-1': '#666666',
  'text-primary': '#1E2F4B',
  'text-secondary': '#8E96A4',
  'text-secondary-dark': '#7C8697',
  'text-tertary': '#000000',
  'text-white': '#FFFFFF',
  'text-error': '#F04C41',
  'text-error-2': '#CD6200',
  'Label-Primary': '#181a1f',
  'Label-Secondary': '#8E96A4',
  'Label-Fifth': '#1E2F4B',
  'Label-Sixth': '#294c85',
  'Label-Seventh': '#245cb8',
  'Label-Confirm': '#00B530',
  'Label-Error-Primary': '#F04C41',
  'Label-Error-Secondary': '#dd3125',
  'Label-Error-Tertiary': '#ba251b',
  'Label-Onsurface': '#fff',
  'Label-Quaternary': '#c9cdd3',
  'Label-GU-Primary': '#1380ff',
  'Label-GU-Secondary': '#006ae7',
  'Label-GU-Tertiary': '#005fce',
  'Interface-Seventh': '#1E2F4B',
  'Interface-Eighth': '#294C85',
  'Interface-Onsurface': '#fff',
  'Background-White': '#fff',
  'Background-Confirm': '#ECFFF1',
  'Background-Error': '#FFF7F6',
  'Background-Primary': '#fff',
  'Background-Tertiary': '#F2F2F2',
  'Background-Quaternary': '#F9FCFF',
  'Background-Dark': '#181a1f',
  'Interface-Orange-Primary': '#ff9900',
  'Interface-Fifth': '#c9cdd3',
  'Interface-Eleven': '#181a1f',
  'Interface-GU-Primary': '#1380FF',
  'Interface-GU-Secondary': '#006ae7',
  'Interface-GU-Tertiary': '#005fce',
  'Interface-Quaternary': '#005fce',
  'Accent-Error-Primary': '#f04c41',
  'Accent-Error-Secondary': '#dd3125',
  'Accent-Error-Tertiary': '#ba251b',
}
export default Object.keys(colorsMap)
